import { BuyerPremiumImageDetailModel } from "./buyer.premium.image.detail";

export class PagedPremiumEventImageViewModel{
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: BuyerPremiumImageDetailModel[] =[];
}